import { createContext, useContext } from 'react';

interface VideoPlayerSyncState {
    isPlayingGlobal: boolean;
    setIsPlayingGlobal: (playing: boolean) => void;
    maxDurationGlobal: number;
    setMaxDurationGlobal: (duration: number, videoKey: string) => void;
    maxDurationVideoKey: string;
    seekTimeGlobal: number;
    setSeekTimeGlobal: (time: number) => void;
    videoEventId: number;
    setVideoEventId: (id: number) => void;
    videoEventDisplayId: string;
    setVideoEventDisplayId: (displayId: string) => void;
    isFullView: boolean;
    setIsFullView: (isFullview: boolean) => void;
    disableSync: boolean;
    setDisableSync: (disable: boolean) => void;
    videosStarted: boolean;
    setVideosStarted: (started: boolean) => void;
    videosWatched: boolean;
    setVideosWatched: (watched: boolean) => void;
    videosEnded: { videoKey: string; ended: boolean }[];
    setVideoEnded: (videoKey: string, ended: boolean) => void;
    allVideosEnded: () => boolean;
    startPlayFromBeginning: boolean;
    setStartPlayFromBeginning: (startPlayFromBeginning: boolean) => void;
}

const VideoPlayerSyncContext = createContext<VideoPlayerSyncState | null>(null);

const useVideoPlayerSync = () => {
    const context = useContext(VideoPlayerSyncContext);
    if (!context) {
        throw new Error('useVideoPlayerSync must be used within a VideoPlayerSyncProvider');
    }
    return context;
};

export { VideoPlayerSyncContext, useVideoPlayerSync };
